// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__19kol","gfeWrapper":"CalendarEvent_gfeWrapper__24N5L"};